'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var anatomy = require('../anatomy.js');
var react = require('@chakra-ui/react');
var input = require('./input.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var $segmentWidth = react.cssVar('segment-width');
var _createMultiStyleConf = react.createMultiStyleConfigHelpers(anatomy.dateFieldAnatomy.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var baseStyle = definePartsStyle({
  root: _objectSpread(_objectSpread({}, input["default"].baseStyle.field), {}, {
    display: 'flex'
  }),
  segment: {
    fontVariantNumeric: 'tabular-nums',
    textAlign: 'end',
    minWidth: $segmentWidth.reference,
    px: 1,
    boxSizing: 'content-box',
    borderRadius: 'sm',
    outline: 'none'
  }
});
var variantDefault = definePartsStyle(function (props) {
  var _input$field, _input$field2, _input$field3, _input$field3$_invali;
  var c = props.colorScheme;
  var input$1 = input["default"].variants["default"](props);
  return {
    root: _objectSpread(_objectSpread({}, input$1.field), {}, {
      _focusWithin: _objectSpread({}, (_input$field = input$1.field) === null || _input$field === void 0 ? void 0 : _input$field._focus),
      _invalid: _objectSpread(_objectSpread({}, (_input$field2 = input$1.field) === null || _input$field2 === void 0 ? void 0 : _input$field2._invalid), {}, {
        _focusWithin: _objectSpread({}, (_input$field3 = input$1.field) === null || _input$field3 === void 0 ? void 0 : (_input$field3$_invali = _input$field3._invalid) === null || _input$field3$_invali === void 0 ? void 0 : _input$field3$_invali._focus)
      })
    }),
    segment: {
      color: 'body-text',
      '&.chakra-date-field_segment--placeholder': {
        color: 'placeholder-color'
      },
      _invalid: {
        color: 'red.400'
      },
      _focus: {
        background: "".concat(c, ".400"),
        color: 'white',
        _invalid: {
          background: 'red.400'
        }
      }
    }
  };
});
var variantFloating = definePartsStyle(function (props) {
  var _input$field4, _input$field5, _input$field6, _input$field6$_invali;
  var c = props.colorScheme;
  var input$1 = input["default"].variants.floating(props);
  return {
    root: _objectSpread(_objectSpread({}, input$1.field), {}, {
      _focusWithin: _objectSpread({}, (_input$field4 = input$1.field) === null || _input$field4 === void 0 ? void 0 : _input$field4._focus),
      _invalid: _objectSpread(_objectSpread({}, (_input$field5 = input$1.field) === null || _input$field5 === void 0 ? void 0 : _input$field5._invalid), {}, {
        _focusWithin: _objectSpread(_objectSpread({}, (_input$field6 = input$1.field) === null || _input$field6 === void 0 ? void 0 : (_input$field6$_invali = _input$field6._invalid) === null || _input$field6$_invali === void 0 ? void 0 : _input$field6$_invali._focus), {}, {
          border: '1px'
        })
      })
    }),
    segment: {
      color: 'gray.400',
      '&.chakra-date-field_segment--placeholder': {
        color: 'placeholder-color'
      },
      _invalid: {
        color: 'red.400'
      },
      _focus: {
        background: "".concat(c, ".400"),
        color: 'white',
        _invalid: {
          background: 'red.400'
        }
      }
    }
  };
});
var variantUnstyled = definePartsStyle(function (props) {
  props.colorScheme;
  var input$1 = input["default"].variants.unstyled;
  return {
    root: _objectSpread({}, input$1.field)
  };
});
var variants = {
  "default": variantDefault,
  floating: variantFloating,
  unstyled: variantUnstyled
};
var sizes = Object.fromEntries(Object.entries(input["default"].sizes).map(function (_ref) {
  var _ref2 = _slicedToArray__default["default"](_ref, 2),
    size = _ref2[0],
    style = _ref2[1];
  return [size, definePartsStyle({
    root: _objectSpread(_objectSpread({}, style.field), {}, {
      py: 2,
      // Height - `py` * 2
      lineHeight: "calc(".concat(style.field.h, " - 1rem)")
    })
  })];
}));
var DateField = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: input["default"].defaultProps
});
exports["default"] = DateField;